import { AudioNote } from '@highlight/common'
import { useMemo } from 'react'

export const useAudioNoteTitle = (conversation: AudioNote | null | undefined) => {
  return useMemo(() => {
    const conversationTitle = conversation?.title?.split?.('from')?.[0] ?? 'Audio Notes'

    const windowTitle = conversation?.meeting?.windowTitle ?? ''
    const windowAppName = conversation?.meeting?.appName ?? ''
    const meetingAppName = conversation?.meeting?.app?.name

    if (meetingAppName) {
      const isDefaultTitle = conversationTitle?.replace(meetingAppName, '')?.trim() === 'Audio Notes'
      if (isDefaultTitle && meetingAppName == 'Google Meet') {
        const meetTitle =
          windowTitle
            ?.split(' - ')?.[1]
            ?.trim()
            ?.replace(windowAppName, '')
            ?.replace('Camera and microphone recording', '')
            ?.trim() ?? windowTitle.replace(windowAppName, '')
        const meetRegex = /\b[a-z]{3}-[a-z]{4}-[a-z]{3}\b/i
        const hasMeetingCode = meetTitle.match(meetRegex)
        if (windowAppName.startsWith(meetTitle) || hasMeetingCode) {
          return `${meetingAppName}`
        }
        return meetTitle?.length > 0 ? meetTitle : meetingAppName
      } else if (isDefaultTitle && meetingAppName == 'Zoom') {
        return meetingAppName
      }
    }
    return conversationTitle
  }, [conversation])
}
